import React from 'react';

import AnniversaryIconDE from '../../assets/svg-components/20years_sg_logo_DE.svg';
import AnniversaryIconEN from '../../assets/svg-components/20years_sg_logo_EN.svg';
import AnniversaryIconES from '../../assets/svg-components/20years_sg_logo_ES.svg';
import AnniversaryIconFR from '../../assets/svg-components/20years_sg_logo_FR.svg';
import AnniversaryIconIT from '../../assets/svg-components/20years_sg_logo_IT.svg';
import ShareIcon from '../../assets/svg-components/share_icon.svg';
import { LANGUAGES } from '../../constants/languages';
import { StoreContext } from '../../store/store';
import AboutUsDialog from '../about-us-dialog/about-us-dialog';
import { Button } from '../button/button';
import { Context } from '../context/context';
import ShareDialog from '../share-dialog/share-dialog';
import { Text } from '../text/text';
import { Translate } from '../translate';
import './header.scss';

const anniversaryIcon = {
  [LANGUAGES.EN]: <AnniversaryIconEN className="bd-header__siteground-logo" />,
  [LANGUAGES.ES]: <AnniversaryIconES className="bd-header__siteground-logo" />,
  [LANGUAGES.IT]: <AnniversaryIconIT className="bd-header__siteground-logo" />,
  [LANGUAGES.DE]: <AnniversaryIconDE className="bd-header__siteground-logo" />,
  [LANGUAGES.FR]: <AnniversaryIconFR className="bd-header__siteground-logo" />
};

type HeaderProps = {
  isShareDialogOpen: boolean;
  setIsShareDialogOpen: Function;
};

export const Header: React.FC<HeaderProps> = ({ isShareDialogOpen, setIsShareDialogOpen }) => {
  const { device } = React.useContext(Context);
  const { state } = React.useContext(StoreContext);
  const lang = state.config.language;

  const [isAboutUsDialogOpen, setIsAboutUsDialogOpen] = React.useState<boolean>(false);

  const AboutUsButton = () => (
    <div className="bd-header__about-us" onClick={() => setIsAboutUsDialogOpen(true)}>
      <Text weight="bold" className="bd-header__text">
        <Translate id="translate.header.about.us" />
      </Text>
    </div>
  );

  const ShareButton = () => (
    <div className="bd-header__share-button" onClick={() => setIsShareDialogOpen(true)}>
      <ShareIcon className="bd-header__share-icon" />
      <Text weight="bold" className="bd-header__text">
        <Translate id="translate.header.share" />
      </Text>
    </div>
  );

  return (
    <div className="bd-header">
      {device.isPhone ? (
        <div className="bd-header__mobile">
          {anniversaryIcon[lang]}
          <Button color="white" size="medium" className="bd-header__mobile__button">
            <AboutUsButton />
            <ShareButton />
          </Button>
        </div>
      ) : (
        <div className="bd-header__desktop">
          <AboutUsButton />
          {anniversaryIcon[lang]}
          <ShareButton />
        </div>
      )}
      <AboutUsDialog isOpen={isAboutUsDialogOpen} setIsDialogOpen={setIsAboutUsDialogOpen} />
      <ShareDialog isOpen={isShareDialogOpen} setIsDialogOpen={setIsShareDialogOpen} />
    </div>
  );
};

export default Header;
